import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomConsultarDocumentosSoporte
 * @author: Anderson Acevedo
 * @version: jdesk_1.01.0004
 **/
class CustomConsultarDocumentosSoporte extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.consultarDocumentos = this.consultarDocumentos.bind(this);
        this.validarfechasConsulta = this.validarfechasConsulta.bind(this);
        this.successDatos = this.successDatos.bind(this);
        this.gridOptionsTbPrincipal = Object.assign({}, this.gridOptions);
        this.gridOptionsConsultarModal = Object.assign({}, this.gridOptions);
        this.limpiar = this.limpiar.bind(this);
        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.mostrarMensajeEmailEnviado = this.mostrarMensajeEmailEnviado.bind(this);
        this.mostrarMensajeEmailFallo = this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeGuardando = this.mostrarMensajeGuardando.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.limpiarTodo = this.limpiarTodo.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);
        this.enviarDoc = this.enviarDoc.bind(this);
        this.successEnviarDoc = this.successEnviarDoc.bind(this);
        this.anularDoc = this.anularDoc.bind(this);
        this.successAnularDoc = this.successAnularDoc.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);

        this.gridOptionsTbPrincipal['onSelectionChanged'] = this.onSelectionChanged;
        this.selectedRows = [];
        this.facturacion_electronica_propia = '';
        this.id = '';
        this.tipo = '';
        this.nombre_archivo = '';
        this.url = '';
        this.concepto = '';
    }

    initForm() {
        console.log("Formulario CustomAsentarOrdenesProduccion,  @version: jdesk_1.01.0004, @author: Anderson Acevedo");
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.estado = '1';
        let hoy = new Date();
        let dia = hoy.getDate();
        let mes = hoy.getMonth() + 1;
        let año = hoy.getFullYear();
        if (mes < 10) {
            mes = '0' + mes;
        }
        if (dia < 10) {
            dia = '0' + dia;
        }
        this.fecha_hoy = año + '-' + mes + '-' + dia;
        this.fecha_inicio = año + '-' + mes + '-01';
        this.traerPropiedades();
        this.getField("desde").setValue(this.fecha_inicio);
        this.getField("consultar").setClick(this.consultarDocumentos);
        this.getField("desde").setOnChange(this.validarfechasConsulta);
        this.getField("hasta").setOnChange(this.validarfechasConsulta);
        this.getField("numero").setOnChange(this.limpiar);
        this.getField("radiobutton").setOnChange(this.limpiar);
        this.getField("sede_auxiliar").setOnChange(this.limpiar);        

        this.getField("radiobutton").setValue("T");


        this.getField("bt_ver_pdf").setClick(() => {

            if (this.selectedRows.length > 0) {
                if (this.facturacion_electronica_propia !== undefined) {
                    this.id = this.selectedRows[0].id_recibido;
                    this.tipo = this.selectedRows[0].tipo_documento;
                    this.nombre_archivo = '';
                    switch (this.tipo) {
                        case "05":
                            this.nombre_archivo = "factura_recibidas";
                            break;
                        case "95":
                            this.nombre_archivo = "nota_credito_recibidas";
                            break;
                        default:
                            break;
                    }
                    this.url = this.facturacion_electronica_propia + "api/generar_pdf/" + this.id + "/" + this.nombre_archivo + "/true";
                    window.open(this.url, '_blank').focus();
                } else {
                    //nothing
                }
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro', 'error');
            }
        });

        this.getField("bt_enviar_doc_electronico").setClick(() => {
            if (this.selectedRows.length > 0) {
                this.enviarDoc();
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro', 'error');
            }
        });

        this.getField("bt_anular_doc_electronico").setClick(() => {
            if (this.selectedRows.length > 0) {
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Anular', 'Desea anular el documento soporte?');
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('modal_conceptos').handleClickOpen();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('SI'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            } else {
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro', 'error');
            }
        });

        this.getField("bt_cancelar_concepto").setClick(() => { this.getField('modal_conceptos').handleClose() });
        this.getField("bt_aceptar_concepto").setClick(() => {
            if (this.getField('concepto').valid()) {
                this.concepto = this.getField('concepto').getValue();
                this.getField('modal_conceptos').handleClose();
                this.anularDoc();
            }
        });
    }

    anularDoc() {
        this.getField('bt_anular_doc_electronico').setDisabled(true);
        let datos = {
            datos: {
                id: this.selectedRows[0].id,
                tipo_documento: this.selectedRows[0].tipo_documento,
                numero: this.selectedRows[0].numero,
                codigo_sucursal: this.selectedRows[0].codigo_sucursal,
                sucursal_ingreso: this.sucursal_ingreso,
                estado_documento: this.selectedRows[0].estado_documento,
                estado_enviada: this.selectedRows[0].estado_enviada===null?'':this.selectedRows[0].estado_enviada,
                concepto: this.concepto,
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'cont-consultardocsoporte', operacion: 'anular_documento', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successAnularDoc,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successAnularDoc(data) {
        this.getField('bt_anular_doc_electronico').setDisabled(false);
        if (data.estado_p === 200) {
            this.getField('confirmModalCustom').toggle(false);
            if (data.data.input !== undefined && data.data.input === true && data.data.mensaje_mostrar !== undefined) {
                //preguntar si desea adicionar
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    let datos = {
                        datos: {
                            id: this.selectedRows[0].id,
                            tipo_documento: this.selectedRows[0].tipo_documento,
                            numero: this.selectedRows[0].numero,
                            codigo_sucursal: this.selectedRows[0].codigo_sucursal,
                            sucursal_ingreso: this.sucursal_ingreso,
                            estado_documento: this.selectedRows[0].estado_documento,
                            estado_enviada: this.selectedRows[0].estado_enviada===null?'':this.selectedRows[0].estado_enviada,
                            concepto: this.concepto,
                            input: '1',//confirma
                        }
                    }
                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'cont-consultardocsoporte', operacion: 'anular_documento', operacion_tipo: 'crear' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successAnularDoc,
                            error: this.error_,
                            general: this.generalFormatPmv
                        });

                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            } else {
                if (data.data.mensaje_mostrar !== undefined) {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                    this.getField('confirmModalCustom').setClickDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                        this.consultarDocumentos();
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                    this.getField('confirmModalCustom').toggle(true);
                } else {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Correcto.');
                    this.getField('confirmModalCustom').setClickDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                        this.consultarDocumentos();
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                    this.getField('confirmModalCustom').toggle(true);
                }

            }
        }
        else {
            this.getField('confirmModalCustom').toggle(false);
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            else if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }


    enviarDoc() {
        this.getField('bt_enviar_doc_electronico').setDisabled(true);
        let datos = {
            datos: {
                id: this.selectedRows[0].id,
                tipo_documento: this.selectedRows[0].tipo_documento,
                numero: this.selectedRows[0].numero,
                fecha: this.selectedRows[0].fecha,
                codigo_sucursal: this.selectedRows[0].codigo_sucursal,
                sucursal_ingreso: this.sucursal_ingreso,
                estado_documento: this.selectedRows[0].estado_documento,
                tipo_operacion: this.selectedRows[0].tipo_operacion + '',
                estado_enviada: this.selectedRows[0].estado_enviada===null?'':this.selectedRows[0].estado_enviada,
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'cont-consultardocsoporte', operacion: 'enviar_doc_electronico', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successEnviarDoc,
                error: this.error_,
                general: this.generalFormatPmv
            });
    }

    successEnviarDoc(data) {
        this.getField('bt_enviar_doc_electronico').setDisabled(false);
        if (data.estado_p === 200) {
            this.getField('confirmModalCustom').toggle(false);
            if (data.data.input !== undefined && data.data.input === true && data.data.mensaje_mostrar !== undefined) {
                //preguntar si desea adicionar
                console.log('es aqiiiiiiiiii')
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    let datos = {
                        datos: {
                            id: this.selectedRows[0].id,
                            tipo_documento: this.selectedRows[0].tipo_documento,
                            numero: this.selectedRows[0].numero,
                            fecha: this.selectedRows[0].fecha,
                            codigo_sucursal: this.selectedRows[0].codigo_sucursal,
                            sucursal_usuario: this.sucursal_ingreso,
                            estado_documento: this.selectedRows[0].estado_documento,
                            tipo_operacion: this.selectedRows[0].tipo_operacion + '',
                            estado_enviada: this.selectedRows[0].estado_enviada===null?'':this.selectedRows[0].estado_enviada,
                            input: '1',//confirma
                        }
                    }
                    this.mostrarMensajeGuardando();
                    this.generalFormatPmv = { tipo_servicio: 'cont-consultardocsoporte', operacion: 'enviar_doc_electronico', operacion_tipo: 'crear' };
                    this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method: 'POST',
                            body: datos,
                            success: this.successEnviarDoc,
                            error: this.error_,
                            general: this.generalFormatPmv
                        });

                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            } else {
                console.log('GHJ?¡')
                if (data.data.mensaje_mostrar !== undefined) {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                    this.getField('confirmModalCustom').setClickDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                        this.consultarDocumentos();
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                    this.getField('confirmModalCustom').toggle(true);
                } else {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Correcto.');
                    this.getField('confirmModalCustom').setClickDialog(() => {
                        this.getField('confirmModalCustom').toggle(false);
                        this.consultarDocumentos();
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                    this.getField('confirmModalCustom').toggle(true);
                }
            }
        }
        else {
            this.getField('confirmModalCustom').toggle(false);
            if (data.data.mensaje_mostrar !== undefined) {
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            else if (data.estado_p === 404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta = Object.values(data.data.errores);
                let keys = Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + keys + ' - ' + respuesta, 'error');
            }
        }
    }



    onSelectionChanged() {
        this.selectedRows = [];
        this.selectedRows = this.gridOptionsTbPrincipal.api.getSelectedRows();
    }


    limpiarTodo() {
        this.getField("numero").setValue("");
        this.getField("codigo_sucursal").setValue("");
    }

    validarfechasConsulta() {
        this.limpiar();
        let fecha_actual = new Date().toISOString().split('T')[0];
        let consultar_desde = new Date(this.getField("desde").getValue()).toISOString().split('T')[0];
        let consultar_hasta = new Date(this.getField("hasta").getValue()).toISOString().split('T')[0];

        if (consultar_desde > consultar_hasta) {
            this.getField('consultar').setDisabled(true);
            this.getField("desde").setError(true, "No puede ser menor a la fecha desde.");
            return false;
        } else {
            this.getField('consultar').setDisabled(false);
            this.getField("hasta").setError(false, "");
        }

        if (consultar_hasta > fecha_actual) {
            this.getField('consultar').setDisabled(true);
            this.getField("hasta").setError(true, "No puede ser mayor a la fecha actual.");
            return false;
        } else {
            this.getField('consultar').setDisabled(false);
            this.getField("hasta").setError(false, "");
        }

        /*let diferencia=new Date(consultar_hasta).getTime()-new Date(consultar_desde).getTime();
        diferencia = diferencia / 1000 / 60 / 60 / 24;
        if(diferencia >this.dias_maximo){
            this.getField("desde").setError(true,"No es posible devolverse más de "+this.dias_maximo+" días.");
            this.getField('consultar').setDisabled(true); 
            return false;
        }else{
            this.getField('consultar').setDisabled(false);
            this.getField("desde").setError(false,"");
        }*/
        return true;

    }

    traerPropiedades() {
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'cont-consultardocsoporte', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.facturacion_electronica_propia = data.data.facturacion_electronica_propia;
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    limpiar() {
        this.getField('desde').setError(false, '');
        this.getField('hasta').setError(false, '');
        this.getField('sede_auxiliar').setError(false, '');
        this.getField('nombre').setError(false, '');
        if(this.getField('nit').getValue() === '')
            this.getField('nombre').setValue('');
        this.getField('numero').setError(false, '');
        this.getField('consultar').setDisabled(false);
        this.gridOptionsTbPrincipal['rowData'] = [];
        let configCell = new Map();
        this.getField('rejilla').initData(this.gridOptionsTbPrincipal, configCell);
        this.getField('rejilla').toggle(false)
        this.getField('bt_enviar_doc_electronico').setVisible(false);
        this.getField('bt_anular_doc_electronico').setVisible(false);
        this.getField('bt_ver_pdf').setVisible(false);
    }

    consultarDocumentos() {
        this.getField('numero').setError(false, '');
        this.getField('nit').setError(false, '');
        this.getField('sede_auxiliar').setError(false, '');
        this.getField('nombre').setError(false, '');
        this.getField('radiobutton').setError(false, '');
        this.getField('desde').setError(false, '');
        this.getField('hasta').setError(false, '');
        let errores = 0;
        if (this.validarfechasConsulta() === false)
            errores++;
        if (this.getField('numero').getValue().toString().trim() !== '') {
            if (!this.getField('numero').valid())
                errores++;
        }
        if (this.getField('nit').getValue().toString().trim() !== '') {
            if (!this.getField('nit').valid())
                errores++;
            if (!this.getField('sede_auxiliar').valid())
                errores++;
            if (!this.getField('nombre').valid())
                errores++;
        }
        if (!this.getField('radiobutton').valid())
            errores++;


        if (errores === 0) {
            let datos = {
                datos: {
                    desde: this.getField("desde").getValue(),
                    hasta: this.getField("hasta").getValue(),
                    radiobutton: this.getField("radiobutton").getValue(),
                    sucursal_ingreso: this.sucursal_ingreso,
                }
            };
            if (this.getField('numero').getValue().toString().trim() !== '') 
                datos.datos.numero=this.getField('numero').getValue();
            if (this.getField('nit').getValue().toString().trim() !== '') {
                datos.datos.nit=this.getField('nit').getValue();
                datos.datos.sede_auxiliar=this.getField('sede_auxiliar').getValue();
            }
            this.mostrarMensajeGenerando();
            this.getField("rejilla").setTipoServicioOperacion("cont-consultardocsoporte-consultar");
            this.getField("rejilla").sendRequest(this.successDatos, datos);
        }

    }

    successDatos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('consultar').setDisabled(true);
            let configCell = new Map();

            configCell.set('id', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.id) }, hide: true });
            configCell.set('valor_sin_iva', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_sin_iva) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor_iva', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_iva) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor_rete_iva', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_sin_iva) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor_rete_fuente', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_sin_iva) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_sin_iva) }, cellStyle: { textAlign: "right" }, width: 110 });


            this.gridOptionsTbPrincipal['rowData'] = data.data;
            this.getField('rejilla').initData(this.gridOptionsTbPrincipal, configCell);
            this.getField('bt_enviar_doc_electronico').setVisible(true);
            this.getField('bt_anular_doc_electronico').setVisible(true);
            this.getField('bt_ver_pdf').setVisible(true);
        } else {
            this.mostrarMensajeNoHayDatos();
            this.getField('rejilla').toggle(false);
        }
    }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }



    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGuardando() {
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

}
FormJaivana.addController("cont-consultardocsoporte", CustomConsultarDocumentosSoporte);
export default CustomConsultarDocumentosSoporte;